<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon fontIcon="group" aria-hidden="true"></mat-icon>
        {{ "settings.project.userList" | translate }}
    </h1>

    <span class="toolbar-spacer"></span>

    <lib-button tooltip="{{'settings.project.addGuest' | translate}}" (click)="selectUser()" icon="group_add"
        size="large"></lib-button>
</mat-toolbar>

<ng-container>
    <div class="table-container">
        <table mat-table [dataSource]="usersData" matSort>
            <ng-container matColumnDef="firstName">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="account_circle" aria-hidden="true"></mat-icon>
                        {{ "form.firstName" | translate }}
                    </div>
                </th>

                <td mat-cell *matCellDef="let _user">{{ _user.firstName }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="badge" aria-hidden="true"></mat-icon>
                        {{ "form.lastName" | translate }}
                    </div>
                </th>

                <td mat-cell *matCellDef="let _user">{{ _user.lastName }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="alternate_email" aria-hidden="true"></mat-icon>
                        {{ "form.email" | translate }}
                    </div>
                </th>

                <td mat-cell *matCellDef="let _user">{{ _user.email }}</td>
            </ng-container>

            <ng-container matColumnDef="subscription">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="subscriptions" aria-hidden="true"></mat-icon>
                        {{ "form.subscription" | translate }}
                    </div>
                </th>

                <td mat-cell *matCellDef="let _user">
                    <mat-checkbox [checked]="_user.isInMailingList" (click)="addUserToMailingList(_user)">
                        {{ "projects.mailing_list" | translate }}
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="header-content">
                        <mat-icon fontIcon="edit"></mat-icon>
                        Actions
                    </div>
                </th>

                <td mat-cell *matCellDef="let _user">
                    <lib-button color="none" textColor="danger" (click)="deleteUser(_user)" icon="delete">
                    </lib-button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="usersColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: usersColumns"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="usersColumns.length">
                    <lib-no-data message="form.search_no_data" description="form.search_no_data_desc" icon="search_off">
                    </lib-no-data>
                </td>
            </tr>
        </table>

        <mat-paginator #usersPaginator [length]="usersCount" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"
            class="paginator">
        </mat-paginator>

        <div *ngIf="loading" class="table-overlay">
            <app-spinner></app-spinner>
        </div>
    </div>
</ng-container>